// Hooks
import ApiServiceV2 from 'services/apiService/apiServiceV2';

const usePaymentApi = () => ({
	createPayment: data => ApiServiceV2.post({ url: '/payments', data }),
	createInvoicePayment: data => ApiServiceV2.post({ url: '/payments/invoice', data }),
	getOrganizationUsers: () => ApiServiceV2.get({ url: '/users/getOrganizationUsers' }),
	getPaycutById: paycutId =>
		ApiServiceV2.post({ url: '/paycuts/getPaycuts', data: { paycutId, type: 'invoice', last_row_id: 0, limit: 1 } }),
	getServicesByDepartment: department_id =>
		ApiServiceV2.post({ url: '/services', data: { department_id } }),
});

export default usePaymentApi;
